var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._t(
        "default",
        function () {
          return [
            _c(
              "div",
              { staticClass: "single container-max page-content" },
              [
                _c("div", { staticClass: "row position-relative" }, [
                  _c(
                    "div",
                    { staticClass: "col-12 col-md-6 col-lg-7 mt-5" },
                    [
                      _vm._t("image-carousel"),
                      _vm._v(" "),
                      _vm.isWishListEnabled
                        ? _c(
                            "div",
                            { staticClass: "svg-wishlist" },
                            [
                              _c("add-to-wish-list", {
                                attrs: {
                                  "variation-id":
                                    _vm.currentVariation.variation.id,
                                  width: 38,
                                  height: 37,
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-12 col-md-6 col-lg-5 mt-md-5" },
                    [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "stick-in-parent",
                              rawName: "v-stick-in-parent",
                            },
                          ],
                        },
                        [
                          _c("div", { staticClass: "producer-group d-flex" }, [
                            _vm.currentVariation.filter.hasManufacturer
                              ? _c(
                                  "div",
                                  { staticClass: "producertag h4 producer" },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.currentVariation.item.manufacturer
                                            .externalName
                                        ) +
                                        "\n                            "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", [
                              _c(
                                "span",
                                {
                                  staticClass: "articlenumber small text-muted",
                                },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "font-weight-bold" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$translate(
                                            "Ceres::Template.singleItemNumber"
                                          )
                                        ) + " "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.currentVariation.variation.number
                                      )
                                    ),
                                  ]),
                                ]
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "h1",
                            {
                              staticClass: "h2 title",
                              attrs: { "data-testing": "item-name" },
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm._f("itemName")(_vm.currentVariation)
                                    ) +
                                    "\n                            "
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _vm._t("tag-list"),
                          _vm._v(" "),
                          _c("hr", { staticClass: "light-line" }),
                          _vm._v(" "),
                          _vm.attributes.length || Object.keys(_vm.units).length
                            ? _c(
                                "div",
                                { staticClass: "mb-3" },
                                [_c("variation-select")],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.currentVariation.variation.bundleType === "bundle"
                            ? _c("item-bundle", {
                                attrs: {
                                  "bundle-type":
                                    _vm.currentVariation.variation.bundleType,
                                  "bundle-components":
                                    _vm.currentVariation.bundleComponents,
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._t("before-price"),
                          _vm._v(" "),
                          _vm.currentVariation.filter.isSalable &&
                          _vm.variationGroupedProperties.length
                            ? _c("div", [_c("order-property-list")], 1)
                            : _vm._e(),
                          _vm._v(" "),
                          _c("graduated-prices"),
                          _vm._v(" "),
                          _c("item-availability"),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "my-3" },
                            [
                              _c(
                                "div",
                                { staticClass: "w-100" },
                                [_vm._t("before-add-to-basket")],
                                2
                              ),
                              _vm._v(" "),
                              _vm.currentVariation.item.itemType === "set"
                                ? _c(
                                    "div",
                                    { staticClass: "alert alert-info w-100" },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            _vm.$translate(
                                              "Ceres::Template.singleItemSetInfo"
                                            )
                                          ) +
                                          "\n                            "
                                      ),
                                    ]
                                  )
                                : _c(
                                    "div",
                                    { staticClass: "my-3 addToBasket1" },
                                    [
                                      _c("add-to-basket", {
                                        attrs: {
                                          "variation-id":
                                            _vm.currentVariation.variation.id,
                                          "is-salable":
                                            !!_vm.currentVariation.filter &&
                                            _vm.currentVariation.filter
                                              .isSalable,
                                          "has-children":
                                            !!_vm.currentVariation.filter &&
                                            _vm.currentVariation.filter
                                              .hasActiveChildren,
                                          "interval-quantity":
                                            _vm.currentVariation.variation
                                              .intervalOrderQuantity || 1,
                                          "minimum-quantity":
                                            _vm.currentVariation.variation
                                              .minimumOrderQuantity,
                                          "maximum-quantity":
                                            !!_vm.currentVariation.variation
                                              .maximumOrderQuantity &&
                                            _vm.currentVariation.variation
                                              .maximumOrderQuantity > 0
                                              ? _vm.currentVariation.variation
                                                  .maximumOrderQuantity
                                              : null,
                                          "order-properties":
                                            _vm.currentVariation.properties.filter(
                                              function (prop) {
                                                return prop.property
                                                  .isOderProperty
                                              }
                                            ),
                                          "has-order-properties":
                                            _vm.currentVariation
                                              .hasOrderProperties,
                                          "has-required-order-property":
                                            _vm.currentVariation
                                              .hasRequiredOrderProperty,
                                          "use-large-scale": false,
                                          "show-quantity": true,
                                          "item-url": _vm._f("itemURL")(
                                            _vm.currentVariation
                                          ),
                                          "is-variation-selected":
                                            _vm.isVariationSelected &&
                                            _vm.currentVariation.filter
                                              .isSalable,
                                          "has-price": _vm._f(
                                            "hasItemDefaultPrice"
                                          )(_vm.currentVariation),
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                              _vm._v(" "),
                              _vm._t("after-price"),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _vm._t("additional-content-after-add-to-basket"),
                          _vm._v(" "),
                          _c("hr", {
                            staticClass: "light-line d-none d-lg-block",
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "vat small text-muted" },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.$translate(
                                      "Ceres::Template.singleItemFootnote1"
                                    )
                                  ) +
                                  " "
                              ),
                              _vm.showNetPrices
                                ? [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.singleItemExclVAT"
                                        )
                                      )
                                    ),
                                  ]
                                : [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.singleItemInclVAT"
                                        )
                                      )
                                    ),
                                  ],
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$translate(
                                      "Ceres::Template.singleItemExclusive"
                                    )
                                  ) +
                                  "\n                        "
                              ),
                              _vm.hasShippingCostsCategoryId
                                ? _c(
                                    "a",
                                    {
                                      attrs: {
                                        "data-toggle": "modal",
                                        href: "#shippingscosts",
                                        title: _vm.$translate(
                                          "Ceres::Template.singleItemShippingCosts"
                                        ),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$translate(
                                            "Ceres::Template.singleItemShippingCosts"
                                          )
                                        )
                                      ),
                                    ]
                                  )
                                : _c(
                                    "a",
                                    {
                                      attrs: {
                                        title: _vm.$translate(
                                          "Ceres::Template.singleItemShippingCosts"
                                        ),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$translate(
                                            "Ceres::Template.singleItemShippingCosts"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "extend-buttons w-100" },
                            [_vm._t("after-add-to-basket")],
                            2
                          ),
                          _vm._v(" "),
                          _vm._t("additional-content-after-vat"),
                        ],
                        2
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-12 d-block d-lg-none nav-tabs-area" },
                    [
                      _c(
                        "ul",
                        {
                          staticClass: "d-flex nav nav-tabs",
                          attrs: { role: "tablist" },
                        },
                        [
                          _vm.isDescriptionTabActive
                            ? _c("li", { staticClass: "nav-item" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass: "active",
                                    attrs: {
                                      "data-toggle": "tab",
                                      href:
                                        "#details-" +
                                        _vm.currentVariation.variation.id,
                                      role: "tab",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.singleItemDescription"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isTechnicalDataTabActive
                            ? _c("li", { staticClass: "nav-item" }, [
                                _c(
                                  "a",
                                  {
                                    class: {
                                      active:
                                        !_vm.isDescriptionTabActive &&
                                        _vm.isTechnicalDataTabActive,
                                    },
                                    attrs: {
                                      "data-toggle": "tab",
                                      href:
                                        "#data-" +
                                        _vm.currentVariation.variation.id,
                                      role: "tab",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.singleItemTechnicalData"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._t("add-detail-tabs"),
                        ],
                        2
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "tab-content row position-relative description-box",
                      },
                      [
                        _c("div", { staticClass: "background-cover" }),
                        _vm._v(" "),
                        _vm.isDescriptionTabActive
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "col-12 col-lg-6 tab-pane active overflow-auto",
                                attrs: {
                                  id:
                                    "details-" +
                                    _vm.currentVariation.variation.id,
                                  role: "tabpanel",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-none d-lg-block text-title t3",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.singleItemDescription"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", {
                                  staticClass: "my-4",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.currentVariation.texts.description
                                    ),
                                  },
                                }),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isTechnicalDataTabActive
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "col-12 col-lg-6 tab-pane overflow-auto",
                                class: {
                                  active:
                                    !_vm.isDescriptionTabActive &&
                                    _vm.isTechnicalDataTabActive,
                                },
                                attrs: {
                                  id:
                                    "data-" + _vm.currentVariation.variation.id,
                                  role: "tabpanel",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-none d-lg-block text-title t3",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.singleItemTechnicalData"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", {
                                  staticClass: "my-4",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.currentVariation.texts.technicalData
                                    ),
                                  },
                                }),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._t("add-detail-tabs-content"),
                      ],
                      2
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _vm._t("shop-builder"),
                _vm._v(" "),
                _vm._t("item-list-container"),
                _vm._v(" "),
                _vm._t("feedback-container"),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "mobileFixedAddToBasket d-none" },
                  [
                    _c(
                      "div",
                      { staticClass: "prices" },
                      [
                        _vm.currentVariation.prices.rrp &&
                        _vm.currentVariation.prices.rrp.unitPrice &&
                        _vm.currentVariation.prices.default.unitPrice &&
                        _vm.currentVariation.prices.rrp.unitPrice.value >
                          _vm.currentVariation.prices.default.unitPrice.value
                          ? [
                              _c("div", { staticClass: "crossprice" }, [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.currentVariation.prices.rrp.unitPrice
                                        .formatted
                                    ) +
                                    " \n                        "
                                ),
                              ]),
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "normalPrice" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(
                                _vm.currentVariation.prices.default.price
                                  .formatted
                              ) +
                              " " +
                              _vm._s(
                                _vm.$translate(
                                  "Ceres::Template.singleItemFootnote1"
                                )
                              ) +
                              "\n                    "
                          ),
                        ]),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "short-info" }, [
                      _vm.currentVariation.attributes[0]
                        ? _c("div", [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.currentVariation.attributes[0].value.names
                                    .name
                                ) +
                                "\n                    "
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentVariation.attributes[1]
                        ? _c("div", [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.currentVariation.attributes[1].value.names
                                    .name
                                ) +
                                "\n                    "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("single-add-to-basket"),
                  ],
                  1
                ),
              ],
              2
            ),
          ]
        },
        {
          getDataField: _vm.getDataField,
          getFilteredDataField: _vm.getFilteredDataField,
        }
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }